import swalLib, { SweetAlertOptions, SweetAlertIcon } from 'sweetalert2';
import router from '@/router';
import Vue from 'vue';
import _, { Dictionary } from 'lodash';
import Q from 'q';
import { Route } from 'vue-router';
import { i18n } from '@/i18n-setup';
import imagePopup from '@/assets/img/popup_warning.png';
import api from './api';

(<any>window).forceCloseSwal = swalLib.close;
let historyCalls = 0;
let query: Dictionary<string> = {};
let onQuery: Dictionary<number> = {};

export const QueryFunctions = {
  copyRoute(route: Route): any {
    return {
      name: route.name,
      params: _.clone(route.params),
      query: query,
      meta: _.clone(route.meta),
    };
  },
  pushQuery(key: string) {
    const route = this.copyRoute(router.currentRoute);
    route.query = {};
    route.query[key] = 'y';
    query = route.query;
    router.push(route);
  },
  replaceQuery(key: string) {
    const route = this.copyRoute(router.currentRoute);
    route.query = {};
    route.query[key] = 'y';
    query = route.query;
    router.replace(route);
  },
  clearQuery() {
    const route = this.copyRoute(router.currentRoute);
    route.query = {};
    query = route.query;
    router.push(route);
  },
  async setKeyToQuery(key: string, value?: string) {
    onQuery[key] = (onQuery[key] || 0) + 1;
    await this.waitNext();
    const route = this.copyRoute(router.currentRoute);
    if (value === undefined) {
      value = 'y';
    }
    if (!route.query[key]) {
      route.query[key] = value;
    }
    if (route.query[key] !== router.currentRoute.query[key]) {
      router.push(route);
    }
  },
  async goBack(key: string) {
    onQuery[key] = (onQuery[key] || 1) - 1;
    await this.waitNext();
    if (router.currentRoute.query[key] && onQuery[key] == 0) {
      delete query[key];
      router.back();
    }
  },
  async removeKeyFromQuery(key: string) {
    onQuery[key] = (onQuery[key] || 1) - 1;
    await this.waitNext();
    const route = this.copyRoute(router.currentRoute);
    if (route.query[key] && onQuery[key] == 0) {
      delete route.query[key];
      delete query[key];
      router.replace(route);
    }
  },
  async waitNext() {
    historyCalls++;
    await Q.delay(historyCalls * 200);
    historyCalls--;
  },
};

let newKey: string | null | undefined = '';

export default {
  swal: swalLib.mixin({
    background: '#FBFFBB',
    //width: '700px',
    allowOutsideClick: false,
  }),
  swalShow(options: SweetAlertOptions) {
    return this.swal.fire(options);
  },
  _toSwalOptions(optionsOrText: SweetAlertOptions | string, icon?: SweetAlertIcon): SweetAlertOptions {
    let opts: SweetAlertOptions = {};
    if (typeof optionsOrText === 'string' || optionsOrText instanceof String) {
      opts.text = optionsOrText as string;
    } else if (typeof optionsOrText === 'object') {
      opts = optionsOrText ?? opts;
    }
    if (icon) {
      opts.icon = icon;
    }
    if (!opts.customClass?.container) {
      opts.customClass = _.extend(opts.customClass || {}, {
        container: 'swal-default',
      });
    }
    if (!opts.icon || opts.icon == 'info' || opts.icon == 'warning' || opts.icon == 'error') {
      opts.icon = undefined;
      opts = Object.assign({ imageUrl: imagePopup, imageWidth: 107, imageHeight: 92 }, opts);
    }
    return opts;
  },
  playNotification() {
    var audio = new Audio(`/sound/notification-${i18n.locale}.wav`);
    audio.play();
  },
  swalSuccess(optionsOrText: SweetAlertOptions | string) {
    const opts = this._toSwalOptions(optionsOrText, 'success');
    return this.swalShow(opts);
  },
  swalWarning(optionsOrText: SweetAlertOptions | string) {
    let opts = this._toSwalOptions(optionsOrText);
    return this.swalShow(opts);
  },
  swalError(optionsOrText: SweetAlertOptions | string) {
    const opts = this._toSwalOptions(optionsOrText, 'error');
    return this.swalShow(opts);
  },
  swalCopy(text: string) {
    this.swal.fire({
      html: `<input id='swal-content-to-copy' readonly class="swal2-input" type="text" style="display: flex;" value='${text}'>`,
      allowOutsideClick: true,
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false,
      /*onOpen: () => {
              const view = $(this.swal.getContent()).find('#swal-content-to-copy');
              view.select();
          },*/
    });
  },
  swalInfo(optionsOrText: SweetAlertOptions | string) {
    const opts = this._toSwalOptions(optionsOrText, 'info');
    return this.swalShow(opts);
  },
  swalShowLoading(msg: string | undefined = undefined) {
    const showLoadingDefaultMsg = <string>i18n.t('popup.swal.LoadingDefaultMsg');
    if (msg === undefined) {
      msg = showLoadingDefaultMsg;
    }
    this.swal.fire({
      text: msg,
      customClass: {
        container: 'swal-default',
      },
    });
    this.swal.showLoading();
  },
  async swalConfirm(
    options: SweetAlertOptions | string,
    onConfirm?: () => void,
    onCancel?: () => void,
  ): Promise<boolean | null> {
    let config: SweetAlertOptions = {
      showCancelButton: true,
      allowOutsideClick: true,
      // confirmButtonText: 'כן',
      // cancelButtonText: 'לא',
      confirmButtonText: <string>i18n.t('popup.swal.btn.Yes'),
      cancelButtonText: <string>i18n.t('popup.swal.btn.No'),
    };
    const opt = this._toSwalOptions(options);
    config = _.extend(config, opt);
    const p = this.swalShow(config);
    p.then(async (r) => {
      await Q.delay(200);
      if (r.value) {
        if (onConfirm) onConfirm();
      } else if (r.dismiss === swalLib.DismissReason.cancel) {
        if (onCancel) onCancel();
      }
    });
    const result = await p;
    if (result.value) {
      return true;
    } else if (result.dismiss === swalLib.DismissReason.cancel) {
      return false;
    }
    return null;
  },
  async swalPrompt(
    options: SweetAlertOptions | string,
    type: SweetAlertOptions['input'] = 'text',
    onConfirm?: (text: any) => string | null,
  ): Promise<string | false | null> {
    //this.setKeyToQuery('alert', 'confirm');
    let config: SweetAlertOptions = {
      showCancelButton: false,
      input: type,
      allowOutsideClick: true,
      confirmButtonText: <string>i18n.t('popup.swal.btn.Confirm'),
      cancelButtonText: <string>i18n.t('popup.swal.btn.No'),
      inputValidator: (value) => {
        if (!value) {
          return 'Value required!';
        }
        return onConfirm ? onConfirm(value) : null;
      },
    };
    const opt = this._toSwalOptions(options);
    config = _.extend(config, opt);
    const p = this.swal.fire(config);
    const result = await p;
    if (result.value) {
      return result.value;
    } else if (result.dismiss === swalLib.DismissReason.cancel) {
      return false;
    }
    return null;
  },

  async cancelVote() {
    var confirms = await this.swalConfirm({
      title: i18n.t('vs.start.popup.cancel.title') as string,
      text: i18n.t('vs.start.popup.cancel.text') as string,
      showCancelButton: true,
      customClass: {
        content: 'ws-preline',
      },
      icon: 'warning',
      confirmButtonColor: '#D9534F',
      cancelButtonColor: '#5CB85C',
      cancelButtonText: i18n.t('vs.start.popup.cancel.btn.continue') as string,
      confirmButtonText: i18n.t('vs.start.popup.cancel.btn.cancel') as string,
      focusCancel: true,
    });
    if (!confirms) {
      return false;
    }

    this.swalShowLoading();
    await Q.delay(500);
    const apiResult = await (await api.CancelVote()).getData(true);
    this.close();
    return apiResult != null;
  },

  async cancelVoteStation() {
    var confirms = await this.swalPrompt(
      {
        icon: 'warning',
        title: i18n.t('vs.station.popup.cancel.title') as string,
        text: i18n.t('vs.station.popup.cancel.text') as string,
        inputPlaceholder: i18n.t('vs.station.popup.cancel.placeholder') as string,
        showCloseButton: true,
        customClass: {
          content: 'ws-preline',
        },
        confirmButtonText: i18n.t('vs.station.popup.cancel.btn.confirm') as string,
      },
      'password',
    );
    if (!confirms) {
      return false;
    }

    this.swalShowLoading();
    await Q.delay(500);
    const apiResult = await (await api.StationCancelVote(confirms)).getData(true);
    this.close();
    return apiResult != null;
  },
  close() {
    this.swal.close();
  },

  // Query string: START
  ...QueryFunctions,
  // Query string: END
};

export function _loadComponent(basePath: string, resolve: any = null, isView: boolean = false) {
  let files: string[] = [];

  if (process.env.VUE_APP_THEME) {
    // client.theme.mode.vue
    files.push(process.env.VUE_APP_CLIENT + '.' + process.env.VUE_APP_THEME + '.' + process.env.VUE_APP_MODE + '.vue');
    // client.theme.default.vue
    files.push(process.env.VUE_APP_CLIENT + '.' + process.env.VUE_APP_THEME + '.default.vue');
    // theme.mode.vue
    files.push(process.env.VUE_APP_THEME + '.' + process.env.VUE_APP_MODE + '.vue');
    // theme.default.vue
    files.push(process.env.VUE_APP_THEME + '.default.vue');
  }

  // client._.mode.vue
  files.push(process.env.VUE_APP_CLIENT + '._.' + process.env.VUE_APP_MODE + '.vue');
  // client._.default.vue
  files.push(process.env.VUE_APP_CLIENT + '._.default.vue');

  // mode.vue
  files.push(process.env.VUE_APP_MODE + '.vue');

  files.push('default.vue');

  let i = -1;
  var component = null;
  while (i++ < files.length) {
    if (isView) {
      component = _importView(basePath + files[i], resolve);
    } else {
      component = _importComponent(basePath + files[i], resolve);
    }
    if (component) {
      return component;
    }
  }
  console.error(basePath + ' component not found');
  return null;
}

export function _importComponent(file: string, resolve: any) {
  try {
    var component = require('@/components/' + file);
    if (component) {
      if (resolve) resolve(component);
      return component;
    }
  } catch (ex) {}
}

export function _importView(file: string, resolve: any) {
  try {
    var component = require('@/views/' + file);
    if (component) {
      if (resolve) resolve(component);
      return component;
    }
  } catch (ex) {}
}

export function _importConfig(file: string, resolve: any) {
  try {
    var component = require('@/config/' + file);
    if (component) {
      if (resolve) resolve(component);
      return component;
    }
  } catch (ex) {}
}

export function _loadConfig(basePath: string, resolve: any = null, extension: string = '.ts', returnDefault = true) {
  let files: string[] = [];
  if (!basePath.endsWith('/')) basePath += '/';

  if (process.env.VUE_APP_THEME) {
    // client.theme.mode.vue
    files.push(
      process.env.VUE_APP_CLIENT + '.' + process.env.VUE_APP_THEME + '.' + process.env.VUE_APP_MODE + extension,
    );
    // client.theme.default.vue
    files.push(process.env.VUE_APP_CLIENT + '.' + process.env.VUE_APP_THEME + '.default' + extension);
    // theme.mode.vue
    files.push(process.env.VUE_APP_THEME + '.' + process.env.VUE_APP_MODE + extension);
    // theme.default.vue
    files.push(process.env.VUE_APP_THEME + '.default' + extension);
  }

  // client._.mode.vue
  files.push(process.env.VUE_APP_CLIENT + '._.' + process.env.VUE_APP_MODE + extension);
  // client._.default.vue
  files.push(process.env.VUE_APP_CLIENT + '._.default' + extension);

  // mode.vue
  files.push(process.env.VUE_APP_MODE + extension);

  files.push('default.ts');

  let i = -1;
  var component = null;
  while (i++ < files.length) {
    component = _importConfig(basePath + files[i], resolve);
    if (component) {
      if (returnDefault) return component.default;
      return component;
    }
  }
  console.error(basePath + ' config not found');
  return null;
}

export function unflatten(data: any) {
  'use strict';
  if (Object(data) !== data || Array.isArray(data)) return data;
  var regex = /\.?([^.\[\]]+)|\[(\d+)\]/g,
    resultholder: any = {};
  for (var p in data) {
    var cur = resultholder,
      prop = '',
      m;
    while ((m = regex.exec(p))) {
      cur = cur[prop] || (cur[prop] = m[2] ? [] : {});
      prop = m[2] || m[1];
    }
    cur[prop] = data[p];
  }
  return resultholder[''] || resultholder;
}
